"use client"
import React, {useState} from 'react'
import {useTekstClient} from "hooks/useTekstClient";
import {useAxios} from "hooks/useAxios";
import {EyeSlashFilledIcon} from "partials/Inloggen/EyeSlashFilledIcon";
import {EyeFilledIcon} from "partials/Inloggen/EyeFilledIcon";

import {useRouter} from 'next/navigation'

export const RecoverPasswordByEmail = () => {


    const {tekst} = useTekstClient()
    const [email, setEmail] = useState('')
    const [isInvalid, setIsInvalid] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)
    const [succesMessage, setSuccesMessage] = useState(null)
    const {post} = useAxios()


    function handleInput(e) {
        const {value} = e.target
        setEmail(value)
    }

    function handleCLick() {
        post('mijn-mkg/wachtwoord/email', {email}).then(() => {
            setIsInvalid(false)
            setErrorMessage(null)
            setSuccesMessage(tekst('passwords:sent'))
        }).catch((error) => {
            const {status} = error
            setIsInvalid(true)
            if (status === 422) {
                setErrorMessage(tekst('passwords:user'))
            }else if(status === 403){
                setErrorMessage(error.response.data.message)
            } else {
                setErrorMessage(tekst('pagina:licentie:algemeen fout'))
            }
        })
    }


    return <div className={`w-full flex justify-center items-center`}>
        <div className={`w-[700px] border border-inherit`}>
            <div
                className={`py-3 w-full bg-kleur-licht-grijs font-bold flex justify-center items-center border-b border-inherit`}>
                {tekst('auth:reset wachtwoord')}
            </div>

            {succesMessage && <p className={`border border-green-700 bg-green/20 rounded-sm m-2 p-2`}>{succesMessage}</p>}

            <div className="flex justify-center flex-col gap-2 my-4">
                <div className="flex justify-center items-center gap-2">
                    <label htmlFor="email" className="whitespace-nowrap w-32 text-right">
                        {tekst('algemeen:email adres')}:
                    </label>
                    <input
                        onFocus={() => {
                            setIsInvalid(false)
                            setErrorMessage(false)
                        }}
                        onChange={handleInput}
                        value={email ?? ''}
                        className={`w-[300px] px-3 py-2 border ${isInvalid ? '!border-red' : 'border-gray-300'} focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        required
                    />
                </div>
                {isInvalid && errorMessage && (
                    <div className="flex justify-center items-center gap-2">
                        <div className="w-32"></div>
                        <p className="text-red text-sm w-[300px]">{errorMessage}</p>
                    </div>
                )}
            </div>



            <div className={`w-full flex justify-center items-center my-4`}>
                <button disabled={email.length === 0} onClick={handleCLick} type={'button'}
                        className={'btn btn-primary'}>{tekst('auth:verstuur wachtwoord reset link')}</button>
            </div>
        </div>
    </div>
}

export const SetNewPassword = ({token, email}) => {
    const {tekst} = useTekstClient()
    const {post} = useAxios()
    const router = useRouter()

    const [isVisibleA, setIsVisibleA] = useState(false);
    const [isVisibleB, setIsVisibleB] = useState(false);

    const [passwordA, setPasswordA] = useState('')
    const [passwordB, setPasswordB] = useState('')

    const [notValid, setNotValid] = useState(null)
    const [errorMessage, setErrorMessage] = useState(false)


    const toggleVisibilityA = () => setIsVisibleA(!isVisibleA);
    const toggleVisibilityB = () => setIsVisibleB(!isVisibleB);

    const handleCLick = () => {
        if(passwordA !== passwordB){
            setNotValid(true)
            setErrorMessage(tekst('auth:wachtwoordnoteq'))
        } else {
            setNotValid(null)
            setErrorMessage(false)

            post(`mijn-mkg/wachtwoord/herstel`, {email, token, password: passwordA, password_confirmation: passwordB}).then(response => {
                if(response.status === 200){
                    router.push('/mijn-mkg/dashboard')
                    router.refresh();
                }
            }).catch(() => {
                setErrorMessage(tekst(`auth:wachtwoord eisen`))
                setNotValid(true)
            })
        }
    }

    return <div className={`w-full flex justify-center items-center`}>
        <div className={`w-[700px] border border-inherit`}>
            <div className={`py-3 w-full bg-kleur-licht-grijs font-bold flex justify-center items-center border-b border-inherit`}>
                {tekst('auth:reset wachtwoord')}
            </div>

            <div className="flex justify-center flex-col gap-4 my-4 px-4">
                <div className="flex justify-center">
                    <div className="relative w-[300px]">
                        <input
                            id="email"
                            name="email"
                            type="email"
                            value={email}
                            disabled
                            placeholder=" "
                            className="peer w-full block rounded-none border border-gray-300 px-3 pt-6 pb-2 text-gray-900 bg-gray-100 placeholder-transparent"
                        />
                        <label htmlFor="email" className="absolute left-3 top-1 text-xs text-gray-500 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-3 peer-placeholder-shown:text-gray-400 peer-focus:top-1 peer-focus:text-xs peer-focus:text-gray-500">
                            {tekst('algemeen:email adres')}
                        </label>
                    </div>
                </div>

                <div className="flex justify-center">
                    <div className="relative w-[300px]">
                        <input
                            id="password_reset_a"
                            name="password_reset_a"
                            type={isVisibleA ? "text" : "password"}
                            onChange={(e) => setPasswordA(e.target.value)}
                            onFocus={() => {
                                setNotValid(null)
                                setErrorMessage(false)
                            }}
                            autoComplete="new-password"
                            required
                            placeholder=" "
                            className="peer block w-full rounded-none border border-gray-300 px-3 pt-6 pb-2 pr-10 text-gray-900 placeholder-transparent focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        />
                        <label htmlFor="password_reset_a" className="absolute left-3 top-1 text-xs text-gray-500 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-3 peer-placeholder-shown:text-gray-400 peer-focus:top-1 peer-focus:text-xs peer-focus:text-gray-500">
                            {tekst('algemeen:wachtwoord')}
                        </label>
                        <button
                            type="button"
                            onClick={toggleVisibilityA}
                            aria-label="toggle password visibility"
                            className="absolute inset-y-0 right-2 flex items-center bg-transparent border-0 focus:outline-none"
                        >
                            {isVisibleA ? (
                                <EyeSlashFilledIcon className="h-5 w-5 ml-8 text-gray-400" />
                            ) : (
                                <EyeFilledIcon className="h-5 w-5 ml-8 text-gray-400" />
                            )}
                        </button>
                    </div>
                </div>

                <div className="flex justify-center">
                    <div className="relative w-[300px]">
                        <input
                            id="password_reset_b"
                            name="password_reset_b"
                            type={isVisibleB ? "text" : "password"}
                            onChange={(e) => setPasswordB(e.target.value)}
                            onFocus={() => {
                                setNotValid(null)
                                setErrorMessage(false)
                            }}
                            autoComplete="new-password"
                            required
                            placeholder=" "
                            className={`peer block w-full rounded-none border ${(notValid || errorMessage) ? 'border-red' : 'border-gray-300'} px-3 pt-6 pb-2 pr-10 text-gray-900 placeholder-transparent focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500`}
                        />
                        <label htmlFor="password_reset_b" className="absolute left-3 top-1 text-xs text-gray-500 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-3 peer-placeholder-shown:text-gray-400 peer-focus:top-1 peer-focus:text-xs peer-focus:text-gray-500">
                            {tekst('auth:bevestig wachtwoord')}
                        </label>
                        <button
                            type="button"
                            onClick={toggleVisibilityB}
                            aria-label="toggle password visibility"
                            className="absolute inset-y-0 right-2 flex items-center bg-transparent border-0 focus:outline-none"
                        >
                            {isVisibleB ? (
                                <EyeSlashFilledIcon className="h-5 w-5 ml-8 text-gray-400" />
                            ) : (
                                <EyeFilledIcon className="h-5 w-5 ml-8 text-gray-400" />
                            )}
                        </button>
                    </div>
                </div>

                {(notValid || errorMessage) && (
                    <div className="flex justify-center">
                        <p className="text-red text-sm w-[300px]">{errorMessage}</p>
                    </div>
                )}
            </div>

            <div className={`w-full flex justify-center items-center my-4 pb-4`}>
                <button onClick={handleCLick} type={'button'} className={'btn btn-primary'}>
                    {tekst('auth:reset wachtwoord')}
                </button>
            </div>
        </div>
    </div>
}